import React, { useState } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { activarDesactivarMalla } from "../../helpers/api.helper";

const CambiarEstadoMalla = ({ malla, fetchMallas, user }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  // activo undefined/null se considera activo hasta que el campo exista en la DB
  const isActivo = malla.activo !== false;
  const puedeEditar = user.idRol !== "usuarioIT";

  const handleCambiarEstado = async () => {
    setLoading(true);
    const res = await activarDesactivarMalla({
      id: malla.id,
      activo: !isActivo,
    });
    if (res.success) {
      toast({
        title: `Malla ${!isActivo ? "activada" : "desactivada"} correctamente`,
        status: "success",
        isClosable: true,
        duration: 3000,
      });
      fetchMallas();
      onClose();
    } else {
      toast({
        title: "Error al cambiar estado",
        description: res.message || "Error inesperado",
        status: "error",
        isClosable: true,
        duration: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <>
      <Text
        color={isActivo ? "green.500" : "red.500"}
        cursor={puedeEditar ? "pointer" : "default"}
        onClick={puedeEditar ? onOpen : undefined}
        _hover={puedeEditar ? { textDecoration: "underline" } : {}}
        userSelect="none"
        display="inline"
      >
        {isActivo ? "Activo" : "Inactivo"}
      </Text>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader
              color="brand.gris_primario"
              fontSize="lg"
              fontWeight="bold"
            >
              {isActivo ? "Desactivar" : "Activar"} Malla
            </AlertDialogHeader>
            <AlertDialogBody>
              ¿Estás seguro que deseas{" "}
              <strong>{isActivo ? "desactivar" : "activar"}</strong> la malla{" "}
              <strong>{malla.descripcion}</strong>?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} variant="link" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                bg="brand.naranja"
                color="white"
                ml={3}
                isLoading={loading}
                onClick={handleCambiarEstado}
              >
                Confirmar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default CambiarEstadoMalla;
